// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Lwba","footer":"ModalCreateQualiphyProcedure_footer__1zrRV","additionData":"ModalCreateQualiphyProcedure_additionData__1blgj"};